import axios from 'axios'
import { getServerHost } from './get-server-host'
import { getHeaders } from './get-headers'

class Api {
  async post(endpoint: string, data: unknown = {}) {
    return await axios.post(getServerHost(endpoint), data, { headers: getHeaders() })
  }

  async get(endpoint: string) {
    return await axios.get(getServerHost(endpoint), { headers: getHeaders() })
  }

  async put(endpoint: string, data: unknown = {}) {
    return await axios.put(getServerHost(endpoint), data, { headers: getHeaders() })
  }

  async delete(endpoint: string) {
    return await axios.delete(getServerHost(endpoint), { headers: getHeaders() })
  }
}

export const api = new Api()